export const demo = [
        {
            id: "pre-checks",
            title: "Pre-checks",
            subtitle: "Pass/Fail Criteria",
            items: [
                {
                    title: "Interview Hygiene",
                    state: "pass",
                    text: "Professional appearance and setup maintained throughout",
                },
                {
                    title: "No Red Flags",
                    state: "pass",
                    text: "No concerning statements or behaviors detected",
                },
            ],
        },

        {
            id: "impactful-communication",
            title: "Impactful Communication",
            meta: { score: "17/20", progress: 85 },
            sections: [
                {
                    key: "english",
                    title: "English Fluency",
                    score: "4/4",
                    summary: "Clarity and fluency in spoken English",
                    assessment: "Excellent command of English with clear, articulate responses.",
                    evidence: ["Clear pronunciation", "Coherent responses", "Minimal grammatical errors"],
                },
                {
                    key: "structured",
                    title: "Structured Thinking",
                    score: "3/4",
                    summary: "Clear structure and logical flow in responses",
                    assessment: "Mostly well-structured, small room for improvement.",
                    evidence: ["Used STAR in some answers", "Generally logical flow"],
                },
            ],
        },

        {
            id: "core-competencies",
            title: "Core Competencies",
            meta: { score: "6/8", progress: 70 },
            sections: [
                {
                    key: "ownership",
                    title: "High Ownership",
                    score: "3/4",
                    summary: "Demonstration of accountability and responsibility",
                    assessment: "Good ownership demonstration.",
                    evidence: ["Took ownership of results", "Explained personal contributions"],
                },
            ],
        },
    ];